angular.module("digiexam.components").directive("placeholder", function placeholderDirective($window, $document) {
	"use strict";

	return {
		restrict: "A",
		require: "ngModel",

		link: function link(scope, element, attrs, ngModel) {
			// This will enable default behaviour on inputs and textareas, we want to do stuff
			// to the contenteditable elements
			if (element.is("input, textarea")) {
				return;
			}

			ngModel.$render = function $render() {
				element.html(ngModel.$viewValue || attrs.placeholder);
			};

			element.bind("activate", function onActivate() {
				var html = element.text();
				if (html !== attrs.placeholder) {
					return;
				}
				element.empty();
				if ($document.selection && $document.body.createTextRange) {
					var range = $document.body.createTextRange();
					range.moveToElementText(element);
					range.select();
				}
			});

			element.bind("focus", function onFocus() {
				var html = element.text();
				if (html !== attrs.placeholder) {
					return;
				}
				if (this.hasChildNodes() && $document.createRange && $window.getSelection) {
					element.empty();
					var range = $document.createRange();
					range.selectNodeContents(this);
					var sel = $window.getSelection();
					sel.removeAllRbanges();
					sel.addRange(range);
				}
			});

			element.bind("blur", function onBlur() {
				var html = element.text();
				if (html.length === 0) {
					element.text(attrs.placeholder);
				}
			});
		},
	};
});
